import type { Dictionary } from "./types";

export const es: Dictionary = {
  common: {
    skipToContent: "Saltar al contenido",
    brandName: "STRIDE",
    titleTemplate: (pageTitle) => `${pageTitle} — STRIDE`,
    itemCount: (quantity) =>
      `${quantity} ${quantity === 1 ? "artículo" : "artículos"}`,
  },
  languageSwitch: {
    label: "Selector de idioma",
  },
  header: {
    promoShipping: "Envío gratis desde $150 USD",
    promoReturns: "Devoluciones durante 30 días",
    promoCta: "Comprar novedades ↗",
    brandAria: "STRIDE, ir al inicio",
    navAria: "Navegación principal",
    navHome: "Inicio",
    navShop: "Tienda",
    menuOpenLabel: "Menú",
    menuCloseLabel: "Cerrar",
    menuOpenAria: "Abrir navegación",
    menuCloseAria: "Cerrar navegación",
    cartLabel: "Carrito",
    cartAria: (itemsLabel) => `Carrito, ${itemsLabel}`,
  },
  footer: {
    lead: "Muévete con intención.",
    viewCollection: "Ver colección ↗",
    tagline: "Proyecto educativo de comercio electrónico.",
    copyright: "© 2026 STRIDE / Bogotá",
  },
  home: {
    pageTitle: "Inicio",
    kicker: "Colección 01 / 2026",
    titleLine1: "Supera",
    titleLine2: "tu ritmo",
    intro:
      "Equipo diseñado para moverse contigo. Del primer paso al último kilómetro.",
    ctaShop: "Comprar ahora",
    ctaNews: "Ver novedades",
    heroImageAlt: "Atleta corriendo al aire libre durante un entrenamiento",
    heroStampLabel: "RUN / TRAIN / LIVE",
    metaBrand: "STRIDE / MOVE FORWARD",
    metaLocation: "BOG / 4.7110° N",
    categoriesAria: "Categorías principales",
    catRun: "Corre",
    catTrain: "Entrena",
    catLive: "Vive",
    featuredKicker: "Selección / 01",
    featuredTitle: "Lo nuevo se mueve rápido.",
    viewAll: "Ver todo",
    editorialImageAlt: "Atleta entrenando fuerza en un gimnasio luminoso",
    editorialStamp: "TRAIN / 02",
    editorialKicker: "Diseñado para el movimiento",
    editorialTitle: "Sin excusas. Sin atajos.",
    editorialBody:
      "Piezas esenciales, materiales resistentes y comodidad para todos los días. Tu ritmo cambia; tu equipo responde.",
    editorialCta: "Descubrir training",
    manifestoKicker: "STRIDE / Manifiesto",
    manifestoText: "No importa dónde empiezas. Importa que sigues avanzando.",
    manifestoFooter: "Hecho para cada paso.",
  },
  shop: {
    pageTitle: "Tienda",
    kicker: "Tienda / Colección completa",
    season: "Temporada 2026",
    titleLine1: "Equípate.",
    titleLine2: "Supera tu marca.",
    intro:
      "Calzado y accesorios seleccionados para el entrenamiento, la calle y todo lo que hay entre ambos.",
    scrollHint: "Desliza para explorar ↓",
    loadingKicker: "Tienda",
    loadingTitle: "Preparando la colección…",
  },
  catalog: {
    filtersAria: "Filtrar productos",
    filterAll: "Todos",
    filterShoes: "Calzado",
    filterAccessories: "Accesorios",
    sortLabel: "Ordenar",
    sortFeatured: "Destacados",
    sortPriceLow: "Precio: menor a mayor",
    sortPriceHigh: "Precio: mayor a menor",
    heading: "Colección completa",
    count: (visibleCount) => `${String(visibleCount).padStart(2, "0")} productos`,
  },
  audiences: {
    men: "Hombre",
    women: "Mujer",
    unisex: "Unisex",
  },
  product: {
    newBadge: "Nuevo",
    ratingAria: (rating) => `${rating} de 5 estrellas`,
    add: "Añadir al carrito",
    added: "Añadido ✓",
    alt: (title, category) =>
      `${title}, producto de ${category === "shoes" ? "calzado" : "accesorios"} de la colección STRIDE`,
  },
  quantity: {
    label: (name) => `Cantidad de ${name}`,
    decreaseAria: (name) => `Reducir cantidad de ${name}`,
    removeAtZeroAria: (name) => `Eliminar ${name} del carrito`,
    increaseAria: (name) => `Aumentar cantidad de ${name}`,
  },
  cart: {
    pageTitle: "Carrito",
    loading: "Cargando tu equipo…",
    kicker: (lineCount) => `Carrito / ${String(lineCount).padStart(2, "0")}`,
    emptyTitle: "Tu carrito aún no arrancó.",
    emptyBody:
      "Encuentra el equipo que acompaña tu ritmo y vuelve cuando estés listo.",
    exploreCta: "Explorar la tienda",
    title: "Tu equipo.",
    itemsHeading: "Artículos",
    clear: "Vaciar carrito",
    perUnit: "/ unidad",
    remove: "Eliminar",
    summaryKicker: "Resumen",
    summaryTitle: "Total del pedido",
    subtotal: "Subtotal",
    shipping: "Envío",
    free: "Gratis",
    total: "Total",
    progressAria: "Progreso para obtener envío gratis",
    remaining: (formattedAmount) =>
      `Te faltan ${formattedAmount} USD para envío gratis.`,
    earned: "✓ Tu pedido tiene envío gratis.",
    checkout: "Finalizar pedido",
    demoCaption:
      "Demo educativa: no se solicitarán datos ni se procesará ningún pago.",
    demoNotice: "¡Buen entrenamiento! El checkout termina aquí en esta demo.",
  },
  cartStatus: {
    added: (quantity, title) =>
      `${quantity} ${quantity === 1 ? "unidad añadida" : "unidades añadidas"} de ${title}`,
    updated: "Cantidad actualizada",
    removed: "Producto eliminado del carrito",
    cleared: "Carrito vaciado",
  },
  notFound: {
    kicker: "Error / 404",
    title: "Esta ruta no lleva a ningún lado.",
    body: "Vuelve a la pista y sigue explorando la colección.",
    cta: "Volver al inicio",
  },
};
